import { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuid } from 'uuid';
import {
  showEditVehicleDialog,
  hideEditVehicleDialog,
} from '../store/actions/editVehicleDialog.actions';

export const useEditVehicleDialog = () => {
  const dispatch = useDispatch();
  const savedResult = useSelector((state) => state.editVehicleDialog.savedResult);
  const pendingRequest = useRef(null);

  useEffect(() => {
    const request = pendingRequest.current;
    if (request && savedResult?.requestId === request.requestId)
      request.onVehicleUpdated?.(savedResult.vehicle);
  }, [savedResult]);

  const openEditVehicleDialog = useCallback(
    (vehicleId, options = {}) => {
      if (!vehicleId) return;
      const requestId = uuid();
      pendingRequest.current = { ...options, requestId };
      dispatch(showEditVehicleDialog({ vehicleId, requestId }));
    },
    [dispatch]
  );

  const closeEditVehicleDialog = useCallback(
    (requestId) => dispatch(hideEditVehicleDialog(requestId)),
    [dispatch]
  );

  return { openEditVehicleDialog, closeEditVehicleDialog };
};
